import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIconComponent } from './simple-icons-icon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIconComponent ],
    exports:      [ SimpleIconsIconComponent ],
    bootstrap:    []
})
export class SimpleIconsIconModule {}
